<div *ngIf="!!src" class="iframe-wrapper">
  <iframe [src]="src" allow="camera; microphone;" [title]="title || 'Full iframe'"></iframe>
</div>